module.exports = __webpack_public_path__ + "static/media/ipsen.0e30b982.png";